// extracted by mini-css-extract-plugin
export var fontBold = "Qguh2GPNI6M2Tvvpimv1";
export var fontMedium = "OfcX49S6R1dQcazITkbM";
export var fontRegular = "cvTMR6hEP2_LtiCAepmQ";
export var fontSemiBold = "mY17FG5PXOmmPfrD79pN";